module.exports = __webpack_public_path__ + "static/media/Cooked_Stone_Fruit.e0430d9d.webp";